"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/** React component that renders its children client-side only / after first mount */
exports.ClientOnly = function (_a) {
    var children = _a.children;
    var hasMounted = exports.useClientOnly();
    if (!hasMounted) {
        return null;
    }
    return react_1.createElement(react_1.Fragment, { children: children });
};
/** React hook that returns true if the component has mounted client-side */
exports.useClientOnly = function () {
    var _a = react_1.useState(false), hasMounted = _a[0], setHasMounted = _a[1];
    react_1.useEffect(function () {
        setHasMounted(true);
    }, []);
    return hasMounted;
};
